import React, { FC, useState } from 'react'
import { Box, Text, IconButton, Tooltip, useToast } from '@chakra-ui/react'
import { FiCopy, FiCheck } from 'react-icons/fi'

interface CopyableTextProps {
  text: string
  children?: React.ReactNode
  fontSize?: string
  color?: string
  fontWeight?: string | number
}

const CopyableText: FC<CopyableTextProps> = ({
  text,
  children,
  fontSize = 'sm',
  color = '#585858',
  fontWeight = 'normal',
}) => {
  const [copied, setCopied] = useState(false)
  const toast = useToast()

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      toast({
        title: 'Copied!',
        description: `${text} copied to clipboard`,
        status: 'success',
        duration: 2000,
        isClosable: true,
      })
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      toast({
        title: 'Failed to copy',
        description: 'Could not copy to clipboard',
        status: 'error',
        duration: 2000,
        isClosable: true,
      })
    }
  }

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Text fontSize={fontSize} color={color} fontWeight={fontWeight}>
        {children || text}
      </Text>
      <Tooltip label={copied ? 'Copied!' : 'Copy email'}>
        <IconButton
          aria-label="Copy email"
          icon={copied ? <FiCheck /> : <FiCopy />}
          size="xs"
          variant="ghost"
          color={copied ? 'green.500' : 'gray.500'}
          onClick={handleCopy}
          _hover={{
            bg: 'gray.100',
          }}
        />
      </Tooltip>
    </Box>
  )
}

export default CopyableText
